import { useDuviNicheSitePricing } from "./use-duvi-niche-site-pricing";
import { DuviNicheSitePricingView } from "./duvi-niche-site-pricing-view";

/**
 * DuviNicheSitePricing — the pricing route. Thin container: calls the
 * behaviour hook and hands its model to the view (hook + view + container
 * split, architecture §6.1).
 */
export function DuviNicheSitePricing() {
  const model = useDuviNicheSitePricing();
  return <DuviNicheSitePricingView {...model} />;
}
